interface TagChipProps {
  label: string
  color?: string | null
  className?: string
}

export function TagChip({ label, color, className }: TagChipProps) {
  return (
    <span
      className={
        'flex items-center gap-1 rounded-md border border-border/50 bg-background-secondary/60 px-1.5 py-0.5 text-[11px] text-foreground/85' +
        (className ? ` ${className}` : '')
      }
    >
      {color && (
        <span
          className="inline-block size-2 shrink-0 rounded-full"
          style={{ backgroundColor: color }}
        />
      )}
      {label}
    </span>
  )
}
